import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { StyledButton } from '../../../Components/Generics.styled';

const SelectPrimaryColorContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const ColorPickerApplet = styled.div`
    margin-top: 30px;
    width: 100%;
    height: 100px;
    text-align: center;
`;

const ColorPicker = styled.input`
    height: 50px;
    width: 400px;
    padding: 0px;
    border-width: 0px;
    border-color: #fafbf7;
    background-color: #fafbf7;
    cursor: pointer;
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const BackBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

export const validateHex = (hexValue) =>
    /^[#][A-Fa-f0-9]+$/.test(hexValue) && hexValue.length === 7;

const SelectPrimaryColor = (props) => {
    const { handleNavButtonNext, handleNavButtonBack, leadGenerationData, setLeadGenerationData } =
        props;

    return (
        <SelectPrimaryColorContainer>
            <Title>Select a Button Color</Title>
            <ColorPickerApplet>
                <ColorPicker
                    type="color"
                    value={leadGenerationData.theme.primaryColor}
                    onChange={(e) =>
                        setLeadGenerationData({
                            ...leadGenerationData,
                            theme: { ...leadGenerationData.theme, primaryColor: e.target.value },
                        })
                    }
                />
            </ColorPickerApplet>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>

                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={leadGenerationData.theme.primaryColor === ''}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </SelectPrimaryColorContainer>
    );
};

SelectPrimaryColor.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        theme: propTypes.shape({ primaryColor: propTypes.string }),
    }),
    setLeadGenerationData: propTypes.func,
};

SelectPrimaryColor.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: {},
    setLeadGenerationData: () => {},
    role: '',
};
export default SelectPrimaryColor;
